
import { SvgCode } from "../../components/icons";

export default function TestingHomePage() {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-3">
      <SvgCode className="text-muted h-36 w-36" />
      <h1 className="text-muted-foreground text-4xl font-semibold">Testing</h1>
      <p className="text-muted-foreground">
        Hello, welcome to the testing page.
      </p>
    </div>
  );
};